import React, { useEffect } from "react";
import readingTime from "reading-time/lib/reading-time";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

const RichTextReadingTime = ({ richTextRaw, callback }) => {
  useEffect(() => {
    const richTextRootNode = JSON.parse(richTextRaw);
    callback(readingTime(documentToPlainTextString(richTextRootNode)));
  }, [richTextRaw]);
  return <></>;
};

export default RichTextReadingTime;
